import { getToken } from 'resources/api/auth';
import { API } from 'resources/constants/urls';
import socketIOClient from 'socket.io-client';
import React, { useState, useEffect } from 'react';

const SocketProviderContext = React.createContext();

const SocketProvider = ({ children }) => {
    const [socket, setSocket] = useState(null);

    useEffect(() => {
        const token = getToken();
        // Only initialize socket if we have a valid token
        if (!token) {
            console.log('No token available, skipping socket initialization');
            return;
        }

        const socket = socketIOClient(API, {
            // auth como callback: cada reconexión obtiene el token fresco desde storage
            // evita CORS error cuando el server rechaza tokens vencidos con 403 sin header CORS
            auth: (cb) => cb({ token: getToken() }),
            // Usar solo WebSocket: evita problemas de CORS con HTTP polling
            // (NGINX tiene Connection:'upgrade' fijo que interfiere con long-polling)
            transports: ['websocket'],
        });
        setSocket(socket);

        return function cleanup() {
            socket.disconnect();
        };
    }, []);

    return (
        <SocketProviderContext.Provider value={socket}>
            {children}
        </SocketProviderContext.Provider>
    );
};

export const useSocket = () => React.useContext(SocketProviderContext);

export default SocketProvider;
